import React from "react";
import ReactECharts from "echarts-for-react"; // Import ECharts wrapper for React
import { useTheme } from "@mui/material/styles";

export default function LineChart1({
  width,
  height,
  className,
  all_values = [],
  current_values = [],
  finalised_values = [],
  x_values = [],
  format = "{value}",
}) {
  const theme = useTheme();

  const all_color = "rgba(50, 150, 240, 1)";
  const current_color = "rgba(50, 210, 255, 1)";
  const finalised_color = "rgba(50, 250, 255, 1)";
  // I want lighter with opacity 1
  const all_color_light = "rgba(210, 220, 255, 1)";
  const current_color_light = "rgba(200, 240, 255, 1)";
  const finalised_color_light = "rgba(200, 250, 255, 1)";
  const options = {
    grid: {
      left: 40,
      right: 20,
      top: 20,
      bottom: 20,
    },
    xAxis: {
      type: "category",
      data: x_values,
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: format,
      },
    },
    series: [
      {
        name: "Dossiers",
        data: all_values,
        type: "line",
        areaStyle: {}, // Enable area under the line
        lineStyle: {
          color: all_color,
        },
        itemStyle: {
          color: all_color,
        },
        areaStyle: {
          color: all_color_light,
        },
      },
      ,
      {
        name: "En cours",
        data: current_values,
        type: "line",
        areaStyle: {}, // Enable area under the line
        lineStyle: {
          color: current_color,
        },
        itemStyle: {
          color: current_color,
        },
        areaStyle: {
          color: current_color_light,
        },
      },
      {
        name: "Finalisés",
        data: finalised_values,
        type: "line",
        areaStyle: {}, // Enable area under the line
        lineStyle: {
          color: finalised_color,
        },
        itemStyle: {
          color: finalised_color,
        },
        areaStyle: {
          color: finalised_color_light,
        },
      },
    ],
    tooltip: {
      trigger: "axis", // Tooltip for axis-based hover
    },
  };

  return (
    <ReactECharts
      option={options}
      style={{
        width: width || "100%",
        height: height || "300px",
      }}
      className={className}
    />
  );
}
